var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.398,
    height: 26.877,
    viewBox: "0 0 22.398 26.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "csv",
    transform: "translate(-12.5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64109",
    "data-name": "Path 64109",
    d: "M28,5.842A2.424,2.424,0,0,0,25.962,5H14.287C13,5,12.5,5.5,12.5,6.787v23.3c0,1.283.5,1.787,1.787,1.787H33.111c1.283,0,1.787-.5,1.787-1.787V13.935a2.423,2.423,0,0,0-.842-2.034Zm5.338,24c0,.342-.135.476-.477.476H14.54c-.342,0-.477-.134-.477-.476V24.057H33.335ZM19.918,21.719a2.955,2.955,0,0,0,.982-.17l.178.92a3.362,3.362,0,0,1-1.338.224,2.479,2.479,0,0,1-2.73-2.607,2.658,2.658,0,0,1,2.847-2.769,3.076,3.076,0,0,1,1.284.232l-.24.936a2.55,2.55,0,0,0-.99-.193,1.568,1.568,0,0,0-1.663,1.725A1.557,1.557,0,0,0,19.918,21.719Zm3.232-1.292c-.866-.3-1.431-.781-1.431-1.539,0-.889.742-1.57,1.972-1.57a3.2,3.2,0,0,1,1.33.263l-.262.951a2.482,2.482,0,0,0-1.091-.248c-.51,0-.758.232-.758.5,0,.332.294.479.967.735.921.34,1.353.82,1.353,1.555,0,.874-.673,1.617-2.1,1.617a3.41,3.41,0,0,1-1.477-.317l.24-.974a3,3,0,0,0,1.307.325c.541,0,.828-.224.828-.565C24.023,20.838,23.776,20.652,23.15,20.428ZM25.585,17.4h1.292l.634,2.2c.178.619.34,1.214.464,1.864H28c.131-.627.294-1.245.472-1.841l.665-2.228h1.253l-1.756,5.213H27.256Zm7.749-1.448H14.063V7.039c0-.342.134-.476.477-.476h11.9c.171,0,.238.067.238.238v4.632c0,1.283.5,1.787,1.787,1.787H33.1c.171,0,.238.067.238.238Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.6c3580e8d54cde67bfeb05b896308a85.svg";
export { ForwardRef as ReactComponent };